/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var initHeaderCarousel = function() {
    $("#header-carousel").owlCarousel({
      navigation : true,
      navigationText: [
        '<span class="arrow arrow-left"></span>',
        '<span class="arrow arrow-right"></span>'
      ],
      autoPlay: 3000,
      stopOnHover: true,
      slideSpeed : 2000,
      paginationSpeed : 400,
      singleItem: true, // "singleItem:true" is a shortcut for:
      /*items : 1,
      itemsDesktop : false,
      itemsDesktopSmall : false,
      itemsTablet: false,
      itemsMobile : false*/
    });
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        if (!Modernizr.flexbox || !Modernizr.flexwrap) {
          flexibility(document);
        }

        $('.link-tooltip').tooltip();

        $('[data-toggle="tooltip"]').tooltip({
          html: true,
          delay: {
            "show": 100,
            "hide": 200
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        initHeaderCarousel();

        $("#partner-carousel").owlCarousel({
          navigation : true, // Show next and prev buttons
          pagination: false,
          navigationText: [
            '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
            '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
          ],
          autoPlay: 2000,
          stopOnHover: true,
          items : 4,
          itemsTablet: [768,1]
        });
      },
      finalize: function() {

      }
    },
    'faites_le_test': {
      init: function() {
        initHeaderCarousel();
      }
    },
    'telecharger_le_livre_blanc': {
      init: function() {
        initHeaderCarousel();
      }
    },
    'methodologie': {
      init: function() {
        $('.circle').on('click', function() {
          var target = $(this).data('anchor');
          var speed = 750;
          var destPos = $('#'+target).offset().top;
          destPos -= $('.navbar').height();
          $('html, body').animate( { scrollTop: destPos}, speed );
          return false;
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
